import React, { useState } from 'react'
import '../assets/css/ToolPanel.scss'

const ToolPanel = (props) => {
    const [minimized, setMinimized] = useState(false)

    let classname = 'main-parent toolpanel'
    classname += props.visible ? ' visible' : ''
    classname += minimized ? ' minimized' : ''

    return (
        <div className={classname}>
            {/* <div className='minimizer' onClick={() => setMinimized(!minimized)} /> */}
            <div className='holder sbar'>{props.children}</div>
        </div>
    )
}

export default ToolPanel
